import { colors } from "../../../styles/colors";
import fontWeight from "../../../styles/mui/fontWeight";

export const ProviderMaterialsHeader = () => ({
  backgroundColor: colors.fonts[18],
  padding: "4rem 1.5rem",
  height: "11rem",
});

export const RowTableCell = (removeBorder: boolean) => ({
  borderBottom: removeBorder ? "unset" : `1px solid ${colors.portalColor[10]}`,
});

export const HeaderTableCell = () => ({
  borderTop: `1px solid ${colors.portalColor[10]}`,
  borderBottom: `3px solid ${colors.portalColor[10]}`,
  padding: "0.8rem",
});

export const AuthContainer = {
  display: "flex",
  flexDirection: "column",
  maxWidth: "100%",
  minWidth: "90%",
  overflowY: "auto",
};

export const InformationGrid = () => ({
  padding: "1rem 1rem 0",
});

export const GridContainer = () => ({
  backgroundColor: colors.white[1],
  paddingBottom: "0.7rem",
  display: "flex",
  flexDirection: "column",
  maxWidth: "100%",
  minWidth: "90%",
  minHeight: "75vh",
  maxHeight: "75vh",
  overflowY: "auto",
});

export const SpanStyle = {
  color: colors.portalColor[4],
};

export const DownloadButton = (isDownloaded: boolean) => ({
  height: "2.6rem",
  fontSize: "1rem",
  fontWeight: fontWeight[4],
  backgroundColor: isDownloaded ? colors.portalColor[29] : "default",
  "&:hover": {
    backgroundColor: colors.portalColor[29],
  },
  transition: "all 0.3s ease",
});
